// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-afmeld-nyhedsbrev-js": () => import("./../../../src/pages/afmeld-nyhedsbrev.js" /* webpackChunkName: "component---src-pages-afmeld-nyhedsbrev-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-login-js": () => import("./../../../src/pages/login.js" /* webpackChunkName: "component---src-pages-login-js" */),
  "component---src-pages-nyhedsbrev-tak-for-din-tilmelding-js": () => import("./../../../src/pages/nyhedsbrev-tak-for-din-tilmelding.js" /* webpackChunkName: "component---src-pages-nyhedsbrev-tak-for-din-tilmelding-js" */),
  "component---src-pages-vores-dyr-js": () => import("./../../../src/pages/vores-dyr.js" /* webpackChunkName: "component---src-pages-vores-dyr-js" */)
}

